import React from 'react';
import { Form } from 'react-final-form';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { setAiChatsToCompany } from '../../../../redux/customers/customersActions';
import getAiChatsOptionsFromArray from '../../../../utils/getAiChatsOptionsFromArray';
import AIChatsFormInner from './AIChatsFormInner';

function AIChatsForm() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const aiChatTypes = useSelector((state) => state.customers.customerInfo?.aiChatTypes);

  const initialValues = {
    assignedAIChats: getAiChatsOptionsFromArray(aiChatTypes) ?? [],
  };

  const handleChangeAiChats = async (values) => {
    await dispatch(setAiChatsToCompany({ aiChats: values.assignedAIChats, companyId: id }));
  };

  return (
    <Form
      initialValues={initialValues}
      onSubmit={handleChangeAiChats}
      subscription={{
        submitting: true,
        submitFailed: true,
        submitSucceeded: true,
      }}
      render={({ handleSubmit }) => <AIChatsFormInner onSubmit={handleSubmit} />}
    />
  );
}

export default AIChatsForm;
